import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api } from "@/lib/api";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, AreaChart, Area } from "recharts";
import { formatCAD } from "@/lib/utils-cart";

export default function Analytics() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/analytics/overview").then((r) => setData(r.data)); }, []);

  return (
    <DashboardLayout title="Analytics" subtitle="Revenue, orders, and product performance.">
      {!data ? (
        <div className="text-muted-foreground">Loading…</div>
      ) : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            <Card label="Revenue" value={formatCAD(data.revenue)} />
            <Card label="Orders" value={data.orders} />
            <Card label="AOV" value={formatCAD(data.aov)} />
            <Card label="Customers" value={data.customers} />
          </div>

          <div className="mt-6 grid lg:grid-cols-2 gap-4">
            <div className="v-card">
              <h3 className="font-display text-lg font-semibold text-primary">Revenue (14d)</h3>
              <div className="mt-4 h-72">
                <ResponsiveContainer>
                  <AreaChart data={data.series}>
                    <defs><linearGradient id="g" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="hsl(var(--chart-2))" stopOpacity={0.4} /><stop offset="100%" stopColor="hsl(var(--chart-2))" stopOpacity={0} /></linearGradient></defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
                    <XAxis dataKey="date" tick={{ fontSize: 10 }} />
                    <YAxis tick={{ fontSize: 10 }} />
                    <Tooltip />
                    <Area dataKey="revenue" stroke="hsl(var(--chart-2))" fill="url(#g)" strokeWidth={2} />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className="v-card">
              <h3 className="font-display text-lg font-semibold text-primary">Orders (14d)</h3>
              <div className="mt-4 h-72">
                <ResponsiveContainer>
                  <BarChart data={data.series}>
                    <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
                    <XAxis dataKey="date" tick={{ fontSize: 10 }} />
                    <YAxis tick={{ fontSize: 10 }} />
                    <Tooltip />
                    <Bar dataKey="orders" fill="hsl(var(--chart-1))" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>

          <div className="mt-6 v-card">
            <h3 className="font-display text-lg font-semibold text-primary">Top products</h3>
            <div className="mt-4 grid md:grid-cols-2 gap-3">
              {data.top_products?.map((p, i) => (
                <div key={p.id} className="flex items-center gap-3 py-2 border-b border-border last:border-0">
                  <span className="font-display font-black text-2xl text-muted-foreground w-8">{i + 1}</span>
                  <span className="flex-1 font-medium">{p.title}</span>
                  <span className="font-mono">{formatCAD(p.revenue)}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  );
}

function Card({ label, value }) {
  return <div className="v-card"><div className="text-xs uppercase tracking-wider text-muted-foreground">{label}</div><div className="font-display font-black text-2xl text-primary mt-1">{value}</div></div>;
}
